import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d75a84f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Be the first to find out about the latest workshops, promotions and online exclusives.", -1 /* HOISTED */))
const _hoisted_2 = {
  key: 0,
  class: "input-field col s12"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email Address", -1 /* HOISTED */))
const _hoisted_4 = {
  key: 1,
  class: "col s12"
}
const _hoisted_5 = {
  class: "btn waves-light right",
  type: "submit",
  name: "action"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons left" }, "send", -1 /* HOISTED */))
const _hoisted_7 = { key: 0 }

export function render(_ctx, _cache) {
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_Form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        (_ctx.showFrom)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_Field, {
                name: "email",
                type: "email",
                rules: _ctx.validateEmail,
                class: "validate"
              }, null, 8 /* PROPS */, ["rules"]),
              _hoisted_3,
              _createVNode(_component_ErrorMessage, {
                name: "email",
                class: "helper-text"
              })
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.showFrom)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.subscribeButtonText) + " ", 1 /* TEXT */),
                _hoisted_6
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onSubmit"]),
    (_ctx.showConfirmation)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_7, "Thank you, your sign-up request was successful!"))
      : _createCommentVNode("v-if", true)
  ]))
}